/**
*@title 오시는길 (대중교통)
*@date 2022-02-07
*@author 홍수희
*@desc
*@etc(change)
*/
/**
 https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3245.953051961534!2d129.13298774367587!3d35.554861655918145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3566254712f9b7d5%3A0xbb441f1657f8964!2z7Jq47IKw7KCE7Iuc7Luo67Kk7IWY7IS87YSw!5e0!3m2!1sko!2skr!4v1619053588750!5m2!1sko!2skr
                                 */

import React from 'react';
import { t } from 'i18next';

import Transport from './Transport';

const Direction = () => {
    return(
        <div className="mid-section-wrap-01">
            <div className="cnt-section-wrap-direction">
                <div className="mid-section-cnt">
                    <div className="sect-09-cont-wrap">
                        <div className="sect-09-map-box">
                            <p className="map-add">{t("direction_address")}</p>
                            <div className="map">
                                <iframe
                                    src={t("direction_map_site")}
                                    allowFullScreen="" loading="lazy">
                                </iframe>
                            </div>
                            <Transport/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Direction;